export default "__VITE_ASSET__7C3R3pAZ__";